import DeleteIcon from "@mui/icons-material/Delete";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Zoom,
} from "@mui/material";
import i18n from "i18n/i18n";
import { useBoundStore } from "store/store";

const DeletePopUp = (props:any) => {
  const lang:any = useBoundStore((state) => state.lang);
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ backdropFilter: "blur(4px)" }}
      TransitionComponent={Zoom}
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">{i18n(lang)?.delete_confirmation}</DialogTitle>
      <DialogContent id="alert-dialog-description">
        {i18n(lang)?.are_you_sure_to_delete}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose}>{i18n(lang)?.button_cancel}</Button>
        <Button onClick={props.handleDelete}>
          <DeleteIcon />
          {i18n(lang)?.delete}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePopUp;
